import { render } from "./Edit.vue?vue&type=template&id=4c283f7d"
import script from "./Edit.vue?vue&type=script&setup=true&lang=js"
export * from "./Edit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Agencies/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c283f7d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c283f7d', __exports__)) {
    api.reload('4c283f7d', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=4c283f7d", () => {
    api.rerender('4c283f7d', render)
  })

}


export default __exports__